import { feeTemplatesResource, feeTemplates } from './fee-templates';
import { feeSchedulesResource, feeSchedules } from './fee-schedules';
import { feeTemplateChangesResource } from './fee-template-changes';
import { supabaseConnectionsResource, supabaseConnections } from './supabase-connections';
import { appUsersResource, appUsers } from './app-users';
import { appVersions } from './app-versions';
import { transactionsResource, transactions } from './transactions';
import { appTransactions } from './app-transactions';
import { appTopUps } from './app-topups';
import { rfidTransactions } from './rfid-transactions';
import { activeSessions } from './active-sessions';
import { chargingSessionsResource, chargingSessions } from './charging-sessions';
import { reservationsResource, reservations } from './reservations';
import { messages } from './messages';
import { banners } from './banners';
import { promotions } from './promotions';
import { vendorsResource, vendors } from './vendors';
import { kioskDevicesResource, kioskDevices } from './kiosk-devices';
import { rfidUsersResource, rfidUsers } from './rfid-users';
import { rfidCardsResource, rfidCards } from './rfid-cards';
import { chargerFirmwareResource, chargerFirmware } from './charger-firmware';
import { firmwareUpdatesResource, firmwareUpdates } from './firmware-updates';
import { paymentMethodsResource, paymentMethods } from './payment-methods';
import { paymentGatewaysResource, paymentGateways } from './payment-gateways';
import { vehicleBrandsResource, vehicleBrands } from './vehicle-brands';
import { vehicleModelsResource, vehicleModels } from './vehicle-models';
import { userGroupsResource, userGroups } from './user-groups';
import { reservationPoliciesResource, reservationPolicies } from './reservation-policies';
import { aiPlaybooks } from './ai-playbooks';
import { aiModelConfigs } from './ai-model-configs';

export const resources = {
  'fee-templates': feeTemplatesResource,
  'fee-schedules': feeSchedulesResource,
  'fee-template-changes': feeTemplateChangesResource,
  'supabase-connections': supabaseConnectionsResource,
  'app-users': appUsersResource,
  'app-versions': appVersions,
  'transactions': transactionsResource,
  'app-transactions': appTransactions,
  'app-topups': appTopUps,
  'rfid-transactions': rfidTransactions,
  'active-sessions': activeSessions,
  'charging-sessions': chargingSessionsResource,
  'reservations': reservationsResource,
  'messages': messages,
  'banners': banners,
  'promotions': promotions,
  'vendors': vendorsResource,
  'kiosk-devices': kioskDevicesResource,
  'rfid-users': rfidUsersResource,
  'rfid-cards': rfidCardsResource,
  'charger-firmware': chargerFirmwareResource,
  'firmware-updates': firmwareUpdatesResource,
  'payment-methods': paymentMethodsResource,
  'payment-gateways': paymentGatewaysResource,
  'vehicle-brands': vehicleBrandsResource,
  'vehicle-models': vehicleModelsResource,
  'user-groups': userGroupsResource,
  'reservation-policies': reservationPoliciesResource,
  'ai-playbooks': aiPlaybooks,
  'ai-model-configs': aiModelConfigs,
};

// Export custom translations for custom components
export { feeTemplates, feeSchedules, supabaseConnections, appUsers, transactions, appTransactions, appTopUps, rfidTransactions, activeSessions, chargingSessions, reservations, messages, banners, promotions, vendors, rfidUsers, rfidCards, chargerFirmware, firmwareUpdates, paymentMethods, paymentGateways, vehicleBrands, vehicleModels, userGroups, reservationPolicies, kioskDevices };